<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <el-form-item :label="$t('common.orgName')">
                    <el-select v-model="formInline.orgId" :placeholder="$t('common.form.choseTip')" filterable
                      size="mini" style="width: 150px">
                      <el-option v-for="item in orgIdList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="mini" type="primary" @click="onSearch" class="btn-chaxun">{{
                      $t('common.btn.search') }}</el-button>
                    <el-button size="mini" @click="onClear" class="btn-del">{{ $t('common.btn.cancel') }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button v-if="isPrimaryKey('REPORTANALYSIS_VEHICLEOVERVIEW_DOWN')" type="text"
                  @click="downCar">{{ $t('common.btn.download') }}</el-button>
              </div>
              <div class="rightAll-table">
                <el-table v-loading="loading" ref="dataTable" :height="tableHeight" stripe :span-method="arraySpanMethod" :data="list" :cell-class-name="setClass" style="width: 100%">
                  <el-table-column type="index" :index="indexMethod" :label="$t('common.id')" width="50" align="center">
                  </el-table-column>
                  <el-table-column prop="orgName" :label="$t('common.orgName')" align="center">
                  </el-table-column>
                  <el-table-column prop="carCount" label="总台数(台)" width="90" align="center">
                  </el-table-column>
                  <el-table-column label="驾驶方式" align="center">
                    <el-table-column prop="sitCount" label="坐式(台)" width="75" align="center">
                    </el-table-column>
                    <el-table-column prop="standCount" label="立式(台)" width="75" align="center">
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="电池类型" align="center">
                    <el-table-column prop="leadAcidCount" label="铅酸(台)" width="75" align="center">
                    </el-table-column>
                    <el-table-column prop="lithiumBatteryCount" label="锂电(台)" width="75" align="center">
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="额定载荷分布" align="center">
                    <el-table-column prop="capacityCount1" label="1.5t(台)" width="75" align="center">
                    </el-table-column>
                    <el-table-column prop="capacityCount2" label="2t(台)" width="75" align="center">
                    </el-table-column>
                    <el-table-column prop="capacityCount3" label="2.5t(台)" width="75" align="center">
                    </el-table-column>
                    <el-table-column prop="capacityCount4" label="其他吨位(台)" width="105" align="center">
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="租龄分布" align="center">
                    <el-table-column prop="leaseCount1" label="<=6个月(台)" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="leaseCount2" label="6-12个月(台)" width="105" align="center">
                    </el-table-column>
                    <el-table-column prop="leaseCount3" label="12-24个月(台)" width="115" align="center">
                    </el-table-column>
                    <el-table-column prop="leaseCount4" label=">24个月(台)" width="100" align="center">
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </div>
              <!-- <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table> -->
              <!-- <IPagination ref="page" @PageFun="changeSize"></IPagination> -->
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VehicleOverview from "./VehicleOverview";
export default VehicleOverview;
</script>

<style lang="less" scoped>
::v-deep .el-table__row {
  .addBorder {
    background-color: #2a548e !important;
  }
}
.rightAll-table ::v-deep .el-table th {
    height: 24px !important;
}

@import "../../../assets/styles/Style.less";
</style>
